export default "__VITE_ASSET__CzdNkyDI__"